import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useNewSessionModal } from '../context/NewSessionModalContext';

// Redirect shim — the New Session flow is now a modal (see NewSessionModal.js
// / NewSessionModalContext.js), but this route stays live for old bookmarks
// and deep-links (e.g. `/session/new?client=...`). On mount, open the modal
// with any preselected client(s) and bounce back to a normal page.
export default function NewSession() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { openNewSession } = useNewSessionModal();
  const preselectedClientId = searchParams.get('client');

  useEffect(() => {
    openNewSession({ clientIds: preselectedClientId ? preselectedClientId.split(',') : [] });
    navigate('/clients', { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
